import React, { useState, useEffect } from "react";

//
import { Card } from "react-bootstrap";

//
import FilterDropdown from "../general/FilterDropdown";
import OvertimeChart from "./OvertimeChart";
import BoxLoading from "../general/BoxLoading";

//
import { getFearGreedHistort } from "../../redux/features/coins/actions";

//
import {fearGreedFilters} from '../../constances'

function Overtime() {
  const [loading, setLoading] = useState(false);
  const [chart, setChart] = useState({
    series: [],
    labels: [],
  });


  const [activeFilter, setActiveFilter] = useState({
    name: "7 days",
    value: 7,
  });

  /**
   * Get Fear & Greed History
   */
  const get_fear_greed_histort = async () => {
    // start loading
    setLoading(true);

    // set variable
    let days = activeFilter.value;

    // request
    await getFearGreedHistort( days ).then((res) => {
      if (res) {
        let newChart = { ...chart };
        newChart.series = res.series;
        newChart.labels = res.labels;
        setChart(newChart);
      }
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    get_fear_greed_histort();

    // eslint-disable-next-line
  }, [activeFilter]);

  return (
    <Card className="overtime">
      <Card.Header className="with-dropdown no-border">
        <span className="text-black">Fear & Greed Overtime</span>

        <div className="d-flex">
          <FilterDropdown
            filters={fearGreedFilters}
            activeFilter={activeFilter}
            action={(item) => setActiveFilter(item)}
            title="Time Range"
            fit
          />
        </div>
      </Card.Header>
      <Card.Body>
        <OvertimeChart data={chart} />
      </Card.Body>

      {loading && <BoxLoading />}
    </Card>
  );
}

export default Overtime;
